// extracted by mini-css-extract-plugin
module.exports = {"core":"App_core__3uNYm","detail":"App_detail__1cl32"};